export default __webpack_public_path__ + "static/media/transforming.16bfaed0.svg";